import React, { useContext } from "react";
import { withRouter } from "react-router-dom";

import { BottomNavigation, BottomNavigationAction } from "@material-ui/core";
import { MdBookmarkBorder, MdPlaylistAddCheck } from "react-icons/md";
import { GoHome } from "react-icons/go";

import useStyles from "./styles";
import { Context as ViewsContext } from "../../../context/ViewsContext";
import { UserAvatar } from "../../_common";

const bottomNavitationItems = [
  { label: "Campañas", icon: <GoHome /> },
  { label: "Suscripciones", icon: <MdPlaylistAddCheck /> },
  { label: "Me interesan", icon: <MdBookmarkBorder /> },
  { label: "Ajustes", icon: <UserAvatar toolbar size={24} /> }
];

const Toolbar = ({ history }) => {
  const { toolbarRoot, action } = useStyles();

  const {
    state: { currentView },
    setView
  } = useContext(ViewsContext);

  return (
    <BottomNavigation
      value={currentView}
      onChange={(event, newValue) => {
        history.push("/");
        setView(newValue);
      }}
      className={toolbarRoot}
      id="toolbar"
    >
      {bottomNavitationItems.map((e, i) => (
        <BottomNavigationAction
          showLabel={false}
          key={i}
          icon={e.icon}
          className={action}
        />
      ))}
    </BottomNavigation>
  );
};

export default withRouter(Toolbar);
